<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import shareCommon from "@/js/shareCommon.js";
export default {
    name: 'App',
    data () {
        return {
        isRouterAlive: true,
        paramsUrl: '',
        h5PhoneToken: null,
        }
    },
    mounted() {
        var vm = this;
        vm.$nextTick(function () {
            vm.initPage();
        })
    },
    methods:{
        initPage:function (){
            var vm = this;
            shareCommon.initWeiXinJSSignInfo(vm);
        },
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue